import { getReportingEmotionLabel } from "./confirmedEmotion.js";

const WORD_CLOUD_ALLOWED = new Set([
  "accept", "allow", "appreciate", "breathe", "build", "calm", "care", "celebrate", "choose", "clarify", "connect", "create", "decide", "embrace", "encourage", "enjoy", "excite", "explore", "feel", "focus", "give", "ground", "grow", "heal", "help", "hope", "inspire", "intend", "learn", "listen", "love", "notice", "pause", "peace", "reflect", "release", "respond", "rest", "share", "steady", "support", "trust", "understand", "welcome",
  "supported", "supportive", "grateful", "thankful", "peaceful", "hopeful", "clear", "grounded", "inspired", "loved", "cared", "connected", "relieved", "focused", "present", "kind", "gentle", "open", "aware", "balanced", "centered", "compassionate", "content", "curious", "energized", "free", "safe", "seen", "understood", "valued", "warm",
  "breathing", "creating", "growing", "learning", "listening", "noticing", "pausing", "reflecting", "resting", "sharing", "caring", "giving", "accepting", "releasing", "choosing", "responding", "building", "healing", "trusting", "embracing", "celebrating", "encouraging", "exploring", "focusing", "grounding", "hoping", "intending", "welcoming"
]);

export function getActionsFromInsights(insights) {
  const items = [];
  (insights || []).forEach((item) => {
    const json = item.insight_json || {};
    let plan = Array.isArray(json.action_plan) ? json.action_plan : [];
    if (plan.length === 0 && (json.action || json.small_action)) plan = [json.action || json.small_action];
    const statuses = item.action_statuses && typeof item.action_statuses === "object" ? item.action_statuses : {};
    plan.forEach((text, index) => {
      if (!text || typeof text !== "string") return;
      items.push({
        id: `${item.id}-${index}`,
        text: text.trim(),
        status: statuses[String(index)] || "pending",
        createdAt: item.created_at
      });
    });
  });
  return items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

export function getGratitudeWordsThisMonth(insights) {
  const now = new Date();
  const thisMonth = now.getMonth();
  const thisYear = now.getFullYear();
  const words = {};
  (insights || []).forEach((item) => {
    const d = new Date(item.created_at);
    if (d.getMonth() !== thisMonth || d.getFullYear() !== thisYear) return;
    const j = item.insight_json || {};
    const parts = [
      j.event_reflection,
      j.interpretation_reflection,
      j.evidence_reflection,
      j.response_statement,
      j.gratitude,
      j.use_this_gratitude,
      j.entry_text
    ]
      .filter(Boolean)
      .map((t) => String(t).trim());
    const text = parts.join(" ");
    if (!text) return;
    text
      .toLowerCase()
      .replace(/[^\w\s']/g, " ")
      .split(/\s+/)
      .filter(Boolean)
      .forEach((w) => {
        const raw = w.replace(/^'+|'+$/g, "");
        if (raw.length < 4) return;
        if (!WORD_CLOUD_ALLOWED.has(raw)) return;
        words[raw] = (words[raw] || 0) + 1;
      });
  });
  return Object.entries(words)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 28);
}

export function getSentimentEntries(insights) {
  return (insights || [])
    .map((item) => {
      const sentiment = getReportingEmotionLabel(item);
      if (!sentiment) return null;
      const dateRaw = item.created_at != null ? item.created_at : item.createdAt;
      const date = dateRaw != null && dateRaw !== "" ? dateRaw : new Date().toISOString();
      return { id: item.id, date, sentiment };
    })
    .filter(Boolean);
}
